import { isNil, isEmpty } from 'ramda'

export const isBlank = (val) => isNil(val) || isEmpty(val)
